import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import {
  Bars3Icon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { useUIStore } from '@/stores/uiStore';
import { useAuthStore } from '@/stores/authStore';
import { useLogout } from '@/api/hooks/useAuth';
import { clsx } from 'clsx';
import { NotificationBell } from '@/components/notifications';

export function Header() {
  const { toggleSidebar } = useUIStore();
  const { user } = useAuthStore();
  const logoutMutation = useLogout();

  const handleLogout = () => {
    logoutMutation.mutate();
  };

  return (
    <header className="sticky top-0 z-30 bg-white shadow-levor">
      {/* Animated gradient bar */}
      <div className="header-gradient-bar" />

      <div className="flex items-center justify-between h-16 px-6">
      {/* Right side - menu toggle */}
      <div className="flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-md hover:bg-gray-100 lg:hidden"
          aria-label="פתח/סגור תפריט צד"
        >
          <Bars3Icon className="w-6 h-6 text-gray-600" />
        </button>

        {/* Search - optional */}
        <div className="hidden sm:block">
          <input
            type="text"
            placeholder="חיפוש..."
            className="w-64 px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>
      </div>

      {/* Left side - notifications and profile */}
      <div className="flex items-center gap-4">
        {/* Notifications */}
        <NotificationBell />

        {/* Profile dropdown */}
        <Menu as="div" className="relative">
          <Menu.Button
            className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-100"
            aria-label="תפריט משתמש"
          >
            <UserCircleIcon className="w-8 h-8 text-gray-600" />
            <div className="hidden sm:block text-right">
              <div className="text-sm font-medium text-gray-900">{user?.fullName}</div>
              <div className="text-xs text-gray-500">{user?.role}</div>
            </div>
          </Menu.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <a
                      href="/settings/profile"
                      className={clsx(
                        'flex items-center gap-2 px-4 py-2 text-sm',
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                      )}
                    >
                      <Cog6ToothIcon className="w-5 h-5" />
                      הגדרות
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLogout}
                      className={clsx(
                        'flex items-center gap-2 w-full px-4 py-2 text-sm',
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                      )}
                    >
                      <ArrowRightOnRectangleIcon className="w-5 h-5" />
                      התנתקות
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
        </div>
      </div>
    </header>
  );
}
